<div class="session-killer">
  <div class="page-title">Session Killer</div>
  <p class="page-description">
    Trava operacional (SQL Agent + procedure) que encerra sessões/transações de
    usuário acima do limite. <strong>KILL causa rollback</strong> e erro na
    aplicação. Use dry-run e whitelist antes de ligar em produção. Default:
    desligado.
  </p>

  <div class="config-card" *ngIf="config">
    <div class="config-card__header">
      <div>
        <h3>Trava automática</h3>
        <small>
          Status:
          <span [class.status-on]="config.isEnabled" [class.status-off]="!config.isEnabled">
            {{ config.isEnabled ? 'LIGADA' : 'DESLIGADA' }}
          </span>
        </small>
      </div>
      <p-inputSwitch
        [ngModel]="config.isEnabled"
        (ngModelChange)="onToggleEnabled($event)"
        [disabled]="savingConfig"
      ></p-inputSwitch>
    </div>

    <form class="form-b4a config-form" [formGroup]="configForm" (ngSubmit)="saveMaxMinutes()">
      <div class="field">
        <label for="maxMinutes">MaxMinutes</label>
        <p-inputNumber
          inputId="maxMinutes"
          formControlName="maxMinutes"
          [min]="1"
          [max]="1440"
          [showButtons]="true"
        ></p-inputNumber>
      </div>
      <button
        pButton
        type="submit"
        label="Salvar limite"
        class="p-button-sm"
        [disabled]="savingConfig || configForm.invalid"
      ></button>
    </form>

    <div class="config-card__row">
      <div>
        <h4>Log de kills</h4>
        <small>Grava em dbo.SessionKillerLog quando um KILL ocorre.</small>
      </div>
      <p-inputSwitch
        [ngModel]="config.isLoggingEnabled"
        (ngModelChange)="onToggleLogging($event)"
        [disabled]="savingConfig"
      ></p-inputSwitch>
    </div>

    <small class="config-card__updated" *ngIf="config.updatedAt">
      Última atualização: {{ config.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
      <span *ngIf="config.updatedBy"> por {{ config.updatedBy }}</span>
    </small>
  </div>

  <p-tabView>
    <p-tabPanel header="Dry-run">
      <div class="tab-actions">
        <button
          pButton
          type="button"
          icon="pi pi-eye"
          label="Executar dry-run"
          (click)="runDryRun()"
        ></button>
        <small>Lista candidatos sem executar KILL (ignora IsEnabled).</small>
      </div>

      <p-table
        [value]="targets"
        [paginator]="true"
        [rows]="15"
        [rowHover]="true"
        styleClass="p-datatable-sm"
        emptyMessage="Nenhuma sessão candidata"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Session</th>
            <th>Motivo</th>
            <th>Minutos</th>
            <th>Login</th>
            <th>Host</th>
            <th>Program</th>
            <th>Database</th>
            <th>SQL</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.sessionId }}</td>
            <td>{{ row.killReason }}</td>
            <td>{{ row.elapsedMinutes }}</td>
            <td>{{ row.loginName }}</td>
            <td>{{ row.hostName }}</td>
            <td>{{ row.programName }}</td>
            <td>{{ row.databaseName }}</td>
            <td class="sql-cell" [title]="row.sqlText">{{ row.sqlText }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Whitelist">
      <form
        class="form-b4a whitelist-form"
        [formGroup]="whitelistForm"
        (ngSubmit)="addWhitelist()"
      >
        <div class="field">
          <label for="filterType">Tipo</label>
          <p-dropdown
            inputId="filterType"
            formControlName="filterType"
            [options]="filterTypeOptions"
            optionLabel="label"
            optionValue="value"
          ></p-dropdown>
        </div>
        <div class="field">
          <label for="filterValue">Valor</label>
          <input
            id="filterValue"
            type="text"
            pInputText
            formControlName="filterValue"
            maxlength="256"
          />
        </div>
        <div class="field field--grow">
          <label for="notes">Notas</label>
          <input id="notes" type="text" pInputText formControlName="notes" />
        </div>
        <button pButton type="submit" label="Adicionar" icon="pi pi-plus"></button>
      </form>

      <p-table
        [value]="whitelist"
        [paginator]="true"
        [rows]="15"
        styleClass="p-datatable-sm"
        emptyMessage="Nenhum filtro na whitelist"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Tipo</th>
            <th>Valor</th>
            <th>Ativo</th>
            <th>Notas</th>
            <th>Criado por</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.filterType }}</td>
            <td>{{ row.filterValue }}</td>
            <td>
              <p-inputSwitch
                [ngModel]="row.isEnabled"
                (ngModelChange)="toggleWhitelist(row, $event)"
              ></p-inputSwitch>
            </td>
            <td>{{ row.notes }}</td>
            <td>{{ row.createdBy }}</td>
            <td>
              <button
                pButton
                type="button"
                class="p-button-danger p-button-text p-button-sm"
                icon="pi pi-trash"
                (click)="confirmDeleteWhitelist(row)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel header="Histórico">
      <div class="tab-actions">
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          label="Atualizar"
          class="p-button-outlined"
          (click)="loadLogs()"
        ></button>
      </div>

      <p-table
        [value]="logs"
        [paginator]="true"
        [rows]="20"
        styleClass="p-datatable-sm"
        emptyMessage="Nenhum kill registrado"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Quando</th>
            <th>Session</th>
            <th>Motivo</th>
            <th>Minutos</th>
            <th>Login</th>
            <th>Host</th>
            <th>Program</th>
            <th>SQL</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.killedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{ row.sessionId }}</td>
            <td>{{ row.killReason }}</td>
            <td>{{ row.elapsedMinutes }}</td>
            <td>{{ row.loginName }}</td>
            <td>{{ row.hostName }}</td>
            <td>{{ row.programName }}</td>
            <td class="sql-cell" [title]="row.sqlText">{{ row.sqlText }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</div>

<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
